<template>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="删除中" name="first">
        <order-exception-applying></order-exception-applying>
      </el-tab-pane>
      <el-tab-pane label="已删除" name="second">
        <order-exception-approved></order-exception-approved>
      </el-tab-pane>
    </el-tabs>
  </template>
  <script>

  import OrderExceptionApplying from "./OrderExceptionApplying.vue";
 import OrderExceptionApproved from "./OrderExceptionApproved.vue";
  export default {
    data() {
      return {
        activeName: "first",
      };
    },
    components: {
      OrderExceptionApplying,
      OrderExceptionApproved
    },
    methods: {
      handleClick(tab, event) {
     
      },
   
    },
   
    activated() {
     
     
   
      
    },
  };
  </script>
  <style>
  .el-tabs__header{
    margin:0 0 0 20px;
  }
  .el-tabs__content{
    overflow: auto;
    height: 100%;
    position:static;
  }
  
  </style>
  